export const NEW_TAB_OPEN = 'NEW_TAB_OPEN';

export const openNewTab = url => ({
  type: NEW_TAB_OPEN,
  url
});
